import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS } from 'src/constants/constants';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUploadCCAsset = () => {
  return useMutation({
    mutationFn: uploadCCAsset,
    onSettled: () => {
      queryClient.invalidateQueries(queryKeys.assets.invalidateAll());
      queryClient.invalidateQueries(queryKeys.products.invalidateAll());
      queryClient.invalidateQueries(queryKeys.ccAssets.invalidateAll());
    },
  });
};

export const uploadCCAsset = async (componentAssetsNames: string[]) => {
  const createAssetsActions = componentAssetsNames.map((assetName) => ({
    resource: COLLECTIONS.ASSETS,
    method: 'POST',
    data: {
      name: assetName,
      theme_id: [],
    },
  }));

  const data = {
    data: [...createAssetsActions],
  };

  const response = await requestCCApi({
    url: '/transaction',
    method: 'POST',
    data: data,
  });

  return response?.results;
};
